/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import ConsumeType from './ConsumeType'

const entity = {
  consumeTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: ConsumeType.getList
      }
    },
    required: false
  },
  totalRound: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      default: '',
      rule: [
        v => /^[0-9]\d*$/.test(v) || this.$t('EnterRightNumber')
      ]
    }
  },
  roundTime: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      default: '',
      rule: [
        v => /^[0-9]\d*$/.test(v) || this.$t('EnterRightNumber')
      ]
    }
  },
  maxDineTime: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      default: '',
      rule: [
        v => /^[0-9]\d*$/.test(v) || this.$t('EnterRightNumber')
      ]
    }
  },
  roundDishCount: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      default: '',
      rule: [
        v => /^[0-9]\d*$/.test(v) || this.$t('EnterRightNumber')
      ]
    }
  },
  childRoundDishCount: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      default: '',
      rule: [
        v => /^[0-9]\d*$/.test(v) || this.$t('EnterRightNumber')
      ]
    }
  }
}

const config = {
  add: function (item) {
    item.roundTime = item.roundTime * 60
    item.maxDineTime = item.maxDineTime * 60
    return hillo.post('ConsumeType.php?op=addJpBuffetSetting', {
      ...item,
      langs: JSON.stringify(item.langs)
    }, {
      showLoading: false
    })
  },
  edit: function (item) {
    item.roundTime = item.roundTime * 60
    item.maxDineTime = item.maxDineTime * 60
    return hillo.postWithUploadFile('ConsumeType.php?op=updateJpBuffetSetting', {
      ...item,
      langs: JSON.stringify(item.langs)
    }, {
      showLoading: true
    })
  },
  remove: function (id) {
    return hillo.post('ConsumeType.php?op=deleteJpBuffetSetting', { id })
  },

  load: async function (filter) {
    const res = (await hillo.get('ConsumeType.php?op=showAllBuffetSetting', {
      ...filter
    }))
      .content
    res.forEach(i => {
      i.roundTime = i.roundTime / 60
      i.maxDineTime = i.maxDineTime / 60
    })
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)
